// extracted by mini-css-extract-plugin
export default {"Apercus":"ImporterCapteurCSV_Apercus__AjL1m","label":"ImporterCapteurCSV_label__dAsrf"};